"use client";

const styles = new Proxy({"Video":"Video-0fbfd","videoContainer":"videoContainer-0fbfd"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import Section from "../Section";

type VideoProps = {
  block: {
    lineOne?: string;
    lineTwo?: string;
    srcUrl?: string;
    iframeTitle?: string;
    title?: string;
    isVideoOnTop?: boolean;
  };
};

export default function Video({ block }: VideoProps) {
  const {
    lineOne,
    lineTwo,
    srcUrl,
    iframeTitle,
    title,
    isVideoOnTop = false,
  } = block;

  const patterns = [
    /vimeo\.com\/(\d+)/,
    /player\.vimeo\.com\/video\/(\d+)/,
    /^(\d+)$/,
  ];

  let videoId: string | null = null;
  for (const pattern of patterns) {
    const match = srcUrl?.match(pattern);
    if (match && match[1]) {
      videoId = match[1];
      break;
    }
  }

  return (
    <Section className={`mt-5 ${styles.Video}`} title={title}>
      {!isVideoOnTop && (
        <div className="row">
          <div className="col-12 text-center">
            <p>
              {lineOne ||
                `AI-backed solutions based on human movement analysis.`}
              <br />
              {lineTwo ||
                `Award-winning technology serving over 2 million end
            users.`}
            </p>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <div className={styles.videoContainer}>
            <iframe
              title={iframeTitle || "Walking Recognition"}
              src={
                srcUrl
                  ? `https://player.vimeo.com/video/${videoId}`
                  : "https://player.vimeo.com/video/943589838?h=565c21ca79"
              }
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
            ></iframe>
          </div>
        </div>
      </div>
      {isVideoOnTop && (
        <div className="row">
          <div className="col-12 text-center">
            <p>
              {lineOne ||
                `AI-backed solutions based on human movement analysis.`}
              <br />
              {lineTwo ||
                `Award-winning technology serving over 2 million end
              users.`}
            </p>
          </div>
        </div>
      )}
    </Section>
  );
}
